import React, { useEffect } from 'react';
import axios from 'src/utils/axios';
import moment from 'moment';
import { Card, Container, Box, Backdrop, CircularProgress, Grid, Divider, CardContent, CardHeader, IconButton, Autocomplete, TextField, Button, Checkbox, Snackbar, Typography } from "@mui/material";
import { DataGrid, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';
import { trTR } from '@mui/x-data-grid/locales';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import SearchIcon from '@mui/icons-material/Search';
import trLocale from 'date-fns/locale/tr';
import { Bar } from 'react-chartjs-2';
import Page from 'src/components/Page';
import AlertComponent from 'src/components/Alert';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import PrintIcon from '@mui/icons-material/Print';
import ExcelFileCreator from 'src/components/ExcelFileCreator'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const localeMap = {
  tr: trLocale
};

const styles = {
  root: {
    width: '100%'
  },
  backdrop: {
    zIndex: 2000,
    color: '#fff'
  }
};

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const smsStatusOptions = [
  { label: 'Tümü', value: 0 },
  { label: 'Başarılı', value: 3 },
  { label: 'Başarısız', value: 4 }
]

function SmsTrackingReport({ onClick }) {

  const [smsGeneralData, setSmsGeneralData] = React.useState([]);
  // Chart data: Başarılı/Başarısız SMS volume bucketed over time (day/month/year depending on
  // the span of the actual results) — replaces the old chart, which plotted a handful of
  // hardcoded, unrelated legacy template IDs regardless of what was actually searched.
  const [chartData, setChartData] = React.useState({ labels: [], datasets: [] });
  const [chartSummary, setChartSummary] = React.useState({ total: 0, success: 0, fail: 0, rate: 0 });
  const [loadingx, setLoadingx] = React.useState(false);

  const [talepEdilmeBaslangicTarihi, setTalepEdilmeBaslangicTarihi] = React.useState(
    new Date()
  );

  const [talepEdilmeBitisTarihi, setTalepEdilmeBitisTarihi] = React.useState(
    new Date()
  );
  const formattedBaslangicDate = moment(talepEdilmeBaslangicTarihi).format('MM-DD-YYYY')
  const formattedBitisDate = moment(talepEdilmeBitisTarihi).format('MM-DD-YYYY')
  const [smsSablonBasliklar, setSmsSablonBasliklar] = React.useState([]);
  const [selectedSmsSablonBasliklar, setSelectedSmsSablonBasliklar] = React.useState([]);
  const [smsMarkalar, setSmsMarkalar] = React.useState([]);
  const [selectedMarkalar, setSelectedMarkalar] = React.useState([]);
  const [smsKullanicilar, setSmsKullanicilar] = React.useState([]);
  const [selectedSmsKullanicilar, setSelectedSmsKullanicilar] = React.useState([]);
  const [smsGonderimDurumlar, setSmsGonderimDurumlar] = React.useState([]);
  const [selectedSmsGonderimDurumlar, setSelectedSmsGonderimDurumlar] = React.useState([]);
  const [Warning, setWarning] = React.useState(false);
  const [WarningType, setWarningType] = React.useState('default');
  const [responseMessage, setresponseMessage] = React.useState("");

  // Status color (reserved — never reused for generic categories): "Başarılı" is a state, not
  // an identity, so it gets this fixed color rather than an arbitrary categorical hue. Only the
  // successful-send count is charted per supervisor's request; failed count still shows as a
  // plain number in the stat tiles below, just not visualized as a bar.
  const STATUS_COLORS = { success: '#0ca30c', fail: '#d03b3b' };
  const CHART_SURFACE = '#fcfcfb';

  // NOTE: this app runs Chart.js v2.9.4 (confirmed via node_modules), not v3/v4 — v2 uses a
  // completely different options shape (scales.xAxes/yAxes arrays, top-level legend/tooltips,
  // fontColor instead of color, no per-dataset borderRadius). Using v3/v4-style keys here is
  // silently ignored by v2, which is exactly why beginAtZero wasn't taking effect before.
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    cornerRadius: 4,
    legend: { display: false }, // single series — axis/title already name it, no legend box needed
    tooltips: {
      callbacks: {
        title: (tooltipItems) => tooltipItems[0]?.xLabel,
        label: (tooltipItem) => `Başarılı: ${tooltipItem.yLabel}`
      }
    },
    scales: {
      xAxes: [{
        gridLines: { display: false },
        ticks: { fontColor: '#898781' }
      }],
      yAxes: [{
        gridLines: { color: '#e1e0d9' },
        ticks: {
          beginAtZero: true,
          fontColor: '#898781',
          // Integer-only labels (counts can't be fractional) without forcing a fixed step size,
          // so this stays readable whether totals are single digits (test data) or in the
          // thousands (production) — Chart.js still picks its own sensible auto-step.
          callback: (value) => (Number.isInteger(value) ? value : null)
        }
      }]
    }
  };

  // Builds the chart from whatever rows the last search returned: only successfully-sent SMS,
  // grouped by template (Şablon Başlığı / BASLIK) — one bar per selected template, per request.
  const buildChartData = (rows) => {
    if (!rows || rows.length === 0) {
      setChartData({ labels: [], datasets: [] });
      setChartSummary({ total: 0, success: 0, fail: 0, rate: 0 });
      return;
    }

    const successRows = rows.filter((r) => r.DURUM === 3);

    const counts = new Map(); // BASLIK -> count
    successRows.forEach((r) => {
      const key = r.BASLIK || 'Bilinmiyor';
      counts.set(key, (counts.get(key) || 0) + 1);
    });

    const labels = Array.from(counts.keys());
    const successSeries = labels.map((k) => counts.get(k));

    setChartData({
      labels,
      datasets: [
        {
          label: 'Başarılı',
          data: successSeries,
          backgroundColor: STATUS_COLORS.success,
          borderColor: CHART_SURFACE,
          borderWidth: 2,
          maxBarThickness: 60
        }
      ]
    });

    const totalSuccess = successRows.length;
    const totalFail = rows.length - totalSuccess;
    setChartSummary({
      total: rows.length,
      success: totalSuccess,
      fail: totalFail,
      rate: rows.length > 0 ? Math.round((totalSuccess / rows.length) * 100) : 0
    });
  };

  const handleExportClick = (buttonType) => {
    var exportData = [];
    if (buttonType === 1) {
      smsGeneralData.map((item) => {
        exportData.push({
          'Fiş Numarası': item.FIS_NO,
          'Cep Telefonu': item.CEP_TEL,
          'Sms Şablon Başlığı': item.BASLIK,
          'Sms İçeriği': item.MESAJ,
          'Kullanıcı Adı': item.KULLANICI_ADI,
          'Gonderim Tarihi': moment(item.GONDERIM_TARIHI).format('DD-MM-YYYY h:mm:ss'),
        })
      })
      ExcelFileCreator(exportData, `Sms Şablon Takip Raporu`);
    }
  };

  /* ============================================================================================
     ESKİ GRAFİK (ORIGINAL CHART) — kaldırılmadı, yorum satırına alındı. Geri almak isteyen kişi
     bu bloğu ve aşağıdaki (JSX içindeki) eski <Bar> satırını geri açıp, yeni grafik kodunu
     (chartData/chartSummary/buildChartData/chartOptions ve JSX'teki yeni <Bar>) kaldırabilir.

  const [sendSuccesData, setSendSuccesData] = React.useState([]);
  const [EkgarantiData, setEkGarantiData] = React.useState(0);
  const [FisBaslandi, setFisBaslandi] = React.useState(0);
  const [FarklıMarkaSayı, setFarklıMarkaSayı] = React.useState(0);
  const [MusteriTalebiİptal, setMusteriTalepIptal] = React.useState(0);
  const [MalzemeTeminiYokSayi, setMalzemeTeminYokSayi] = React.useState(0);
  const [MusteriUcretıKabulEtmiyorSayi, setMusteriUcretiKabulEtmiyorSayi] = React.useState(0);
  const [MemnuniyetGarantisiArtemisSayi, setMemnuniyetGarantisiArtemisSayi] = React.useState(0);
  const [MusteriyeGidilemiyorSayi, setMusteriyeGidilemiyorSayi] = React.useState(0);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Chart.js Bar Chart',
      },
    },
  };
  //Düzeltilecek. Dinamik şekilde çekilecek.
  const labels = ['Fiş Başlandı', 'Ys Ekgaranti', 'Müşteri Talebi İptal Ettirdi', 'Müşteri Ürün Farklı Marka', 'Demode Malzeme Temini Yok', 'Müşteri Ücreti Kabul Etmiyor', 'Mücbir Sebep ile Gidilemiyor', 'Memnuniyet Ek Garanti Artemis'];
  //9-39-40-43-41-42-44-55

  const backgroundColors = [
    'rgba(255, 99, 132, 0.5)',
    'rgba(54, 162, 235, 0.5)',
    'rgba(255, 206, 86, 0.5)',
    'rgba(75, 192, 192, 0.5)',
    'rgba(41, 192, 192, 0.5)',
    'rgba(41, 42, 192, 0.5)',
    'rgba(41, 42, 44, 0.5)',
    'rgba(55, 255, 44, 0.5)',
  ];

  const data = {
    labels,
    datasets: [
      {
        label: 'Dataset 1',
        data: [FisBaslandi, EkgarantiData, MusteriTalebiİptal, FarklıMarkaSayı, MalzemeTeminiYokSayi, MusteriUcretıKabulEtmiyorSayi, MusteriyeGidilemiyorSayi, MemnuniyetGarantisiArtemisSayi], // Statik veriler
        //data: [500, 1233, 399, 224, 899, 600, 234, 109, 396],
        backgroundColor: backgroundColors
      }
    ],
  };

  const getSmsGonderilenSmsler_OLD = () => {
    setLoadingx(true)
    axios.get("/GetSmsGonderilenSmsler").then((response) => {
      var successData = [];
      var errorData = [];
      if (response.data.length > 0) {
        response.data.map((i) => {
          if (i.DURUM === 3) {
            successData.push(i);//Gönderilen smsler
          }
          else {
            errorData.push(i);//Gönderilemeyen smsler
          }
        });
        setSmsGeneralData(response.data);
        GrafikDataDoldur(successData);
        setLoadingx(false);
      }
    })
    setLoadingx(false)
  }

  function GrafikDataDoldur(successData) {
    var ekgaranti = successData.filter(i => i.MESAJ_SABLON_ID === 9).length
    setEkGarantiData(ekgaranti)
    var baslandi = successData.filter(i => i.MESAJ_SABLON_ID === 39).length
    setFisBaslandi(baslandi)
    var FarklıMarka = successData.filter(i => i.MESAJ_SABLON_ID === 43).length
    setFarklıMarkaSayı(FarklıMarka)
    var Musteriİptali = successData.filter(i => i.MESAJ_SABLON_ID === 40).length
    setMusteriTalepIptal(Musteriİptali)
    var MalzemeTeminiYok = successData.filter(i => i.MESAJ_SABLON_ID === 41).length
    setMalzemeTeminYokSayi(MalzemeTeminiYok)
    var MusteriUcretıKabulEtmiyor = successData.filter(i => i.MESAJ_SABLON_ID === 42).length
    setMusteriUcretiKabulEtmiyorSayi(MusteriUcretıKabulEtmiyor)
    var MusteriyeGidilemiyor = successData.filter(i => i.MESAJ_SABLON_ID === 44).length
    setMusteriyeGidilemiyorSayi(MusteriyeGidilemiyor)
    var MemnuniyetGarantisiArtemis = successData.filter(i => i.MESAJ_SABLON_ID === 55).length
    setMemnuniyetGarantisiArtemisSayi(MemnuniyetGarantisiArtemis)

  }
  ============================================================================================ */

  const columns = [
    {
      field: 'ID',
      headerName: 'Id',
      width: 100,
    },
    {
      field: 'FIS_NO',
      headerName: 'Fiş Numarası',
      width: 150,
    },
    {
      field: 'CEP_TEL',
      headerName: 'Cep Telefonu',
      width: 110,
      renderCell: (cellValues) => {
        const cepTel = cellValues.row.CEP_TEL;
        // Maskelemek için  üç karakteri (*) ile değiştir
        const maskedCepTel = cepTel ? cepTel.substring(0, 3) + '****' + cepTel.substring(7) : '-';
        return maskedCepTel;
      },
    },
    {
      field: 'BASLIK',
      headerName: 'Sms Şablon Başlığı',
      width: 400,
    },
    {
      field: 'MESAJ',
      headerName: 'Sms İçeriği',
      width: 600,
    },
    {
      field: 'MARKA',
      headerName: 'Marka',
      width: 110,
    },
    {
      field: 'KULLANICI_ADI',
      headerName: 'Kullanıcı Adı',
      width: 110,
    },
    {
      field: 'DURUM_ACIKLAMA',
      headerName: 'Durum',
      width: 150,
    },
    {
      field: 'GONDERIM_TARIHI',
      headerName: 'Gönderilme Tarihi',
      width: 150,
      renderCell: (cellValues) => {
        return (
          cellValues.row.GONDERIM_TARIHI ? moment(cellValues.row.GONDERIM_TARIHI).format('DD-MM-YYYY, HH:mm:ss') : '-'
        );
      },
    },
  ];

  function QuickSearchToolbar(props) {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <Grid container spacing={2} >
          <Grid
            size={{
              xs: 4,
              md: 4
            }}>
            <GridToolbarContainer >
              <GridToolbarExport
                sx={{ color: '#FF9800' }}
                csvOptions={{
                  utf8WithBom: true,
                }} />
            </GridToolbarContainer>
          </Grid>
        </Grid>
      </Box>
    );
  }



  useEffect(() => {
    // getSmsGonderilenSmsler() removed: it unconditionally pulled the full (tens-of-millions-row)
    // dataset on every page load. No query should fire until the user clicks ARA/YAZDIR.
    getSmsSablonBasliklar();
    // getSmsMarkalar() / getSmsKullanicilar() commented out along with their now-removed filter UI.
    // getSmsMarkalar();
    // getSmsKullanicilar();
  }, []);

  // getSmsGonderilenSmsler() / old GrafikDataDoldur() removed: they were dead code left over from
  // before the mount-time auto-fetch was removed, and referenced per-template state that no
  // longer exists (see buildChartData() above for the current chart-building logic).

  const getSmsSablonBasliklar = () => {
    // No setLoadingx() here on purpose: this only populates the Şablon Başlıkları dropdown
    // (a small, near-instant lookup), not the actual report search — it must not trigger the
    // same full-page "Sorgu çalışıyor" overlay used for the real (heavy) query.
    axios.get("/GetSmsRaporSablonBasliklar").then((response) => {
      setSmsSablonBasliklar(response.data)
    })
  }

  const getSmsMarkalar = () => {
    setLoadingx(true)
    axios.get("/GetSmsRaporMarkalar").then((response) => {
      setSmsMarkalar(response.data)
      setLoadingx(false);
    })
  }

  const getSmsKullanicilar = () => {
    setLoadingx(true)
    axios.get("/GetSmsRaporKullanicilar").then((response) => {
      setSmsKullanicilar(response.data)
      setLoadingx(false);
    })
  }

  function SmsSonuclariniFiltreliAra() {
    if (selectedSmsSablonBasliklar.length <= 0) {
      setresponseMessage('Lütfen kutucukları boş bırakmayınız!...');
      setWarning(true);
      setWarningType("error");
      return;
    }

    var SablonBasliklariList = [];
    selectedSmsSablonBasliklar.map((i) => {
      SablonBasliklariList.push(i.ID);
    })

    // Markalar / Kullanıcılar / Sms Gönderim Durumları filters removed from UI (see commented-out
    // Autocomplete blocks below) — these are sent as fixed "no filter" values so the backend's
    // existing bypass conditions (@RAPOR_MARKALAR='0', @RAPOR_KULLANICILAR='Tümü', @SMS_GONDERIM_DURUMLAR=0)
    // apply, matching "only Şablon Başlıkları filter available".
    const data = {
      BaslangicTarihi: formattedBaslangicDate,
      BitisTarihi: formattedBitisDate,
      SmsRaporSablonBasliklar: SablonBasliklariList.toString(),
      SmsRaporMarkalar: '0',
      SmsRaporKullanicilar: 'Tümü',
      SmsRaporGonderimDurumlar: 0
    }


    setLoadingx(true);
    axios.get(`SmsGonderimTakipRaporuAra/${data.BaslangicTarihi}/${data.BitisTarihi}/${data.SmsRaporSablonBasliklar}/${data.SmsRaporMarkalar}/${data.SmsRaporKullanicilar}/${data.SmsRaporGonderimDurumlar}`)
      .then((response) => {
        if (response.data.length > 0) {
          setSmsGeneralData(response.data);
          buildChartData(response.data);
        } else {
          setSmsGeneralData([]);
          buildChartData([]);
        }
        setLoadingx(false);
      })
      .catch(() => {
        setresponseMessage('Rapor alınırken bir hata oluştu!...');
        setWarning(true);
        setWarningType("error");
        setLoadingx(false);
      });
  }

  const WarningClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setWarning(false);
  };
  const handleClick = (reportType) => {
    // Handle click here...
    setReportType(0);
  };
  return (
    <Page>
      <Backdrop sx={styles.backdrop} open={loadingx}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
          <CircularProgress sx={{ color: '#FF9800' }} size={60} />
          <Typography variant="subtitle1" sx={{ color: '#FFFFFF' }}>
            Sorgu çalışıyor
          </Typography>
        </Box>
      </Backdrop>
      <Snackbar
        open={Warning}
        autoHideDuration={10000}
        onClose={WarningClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <AlertComponent onClose={WarningClose} variant={WarningType} message={responseMessage}></AlertComponent>
      </Snackbar>
      <Card>
        <CardHeader
          title="Sms Gönderim Takip Raporu"
          action={
            <IconButton onClick={onClick} style={{ color: 'orange' }}>
              <ArrowBackIcon />
            </IconButton>
          }
        />
        <Divider />
        {/* ESKİ GRAFİK JSX (ORIGINAL CHART JSX) — yorum satırına alındı, silinmedi.
        <Grid container spacing={1}>
          <Grid item xs={3} sm={3} lg={3}>
          </Grid>
          <Grid item xs={6} sm={6} lg={6}>
            <Bar options={options} data={data} />
          </Grid>
          <Grid item xs={3} sm={3} lg={3}>
          </Grid>
        </Grid>
        */}
        {chartData.labels.length > 0 ? (
          <Container maxWidth="xl" sx={{ pt: 2 }}>
            <Grid container spacing={2} sx={{ mb: 2 }}>
              <Grid
                size={{
                  xs: 6,
                  sm: 3
                }}>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography variant="h4" sx={{ color: '#0b0b0b' }}>{chartSummary.total}</Typography>
                  <Typography variant="body2" sx={{ color: '#52514e' }}>Toplam Gönderim</Typography>
                </Box>
              </Grid>
              <Grid
                size={{
                  xs: 6,
                  sm: 3
                }}>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography variant="h4" sx={{ color: '#0ca30c' }}>{chartSummary.success}</Typography>
                  <Typography variant="body2" sx={{ color: '#52514e' }}>Başarılı</Typography>
                </Box>
              </Grid>
              <Grid
                size={{
                  xs: 6,
                  sm: 3
                }}>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography variant="h4" sx={{ color: '#d03b3b' }}>{chartSummary.fail}</Typography>
                  <Typography variant="body2" sx={{ color: '#52514e' }}>Başarısız</Typography>
                </Box>
              </Grid>
              <Grid
                size={{
                  xs: 6,
                  sm: 3
                }}>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography variant="h4" sx={{ color: '#0b0b0b' }}>%{chartSummary.rate}</Typography>
                  <Typography variant="body2" sx={{ color: '#52514e' }}>Başarı Oranı</Typography>
                </Box>
              </Grid>
            </Grid>
            <Box sx={{ height: 320 }}>
              <Bar options={chartOptions} data={chartData} />
            </Box>
          </Container>
        ) : (
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="body2" sx={{ color: '#898781' }}>
              Sonuçları görmek için ARA butonuna basın.
            </Typography>
          </Box>
        )}
        <br></br>
        <Divider />
        {/* Gönderilen smsler */}
        <Container style={styles.container1} maxWidth="xl">
          <CardContent>
            <Grid container spacing={2} style={{ marginBottom: '0.1rem' }}>
              <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
                <Grid
                  size={{
                    xs: 12,
                    sm: 4,
                    lg: 2
                  }}>
                  <DatePicker
                    label="Başlangıç Tarihi"
                    format="dd.MM.yyyy"
                    value={talepEdilmeBaslangicTarihi}
                    onChange={date => {
                      setTalepEdilmeBaslangicTarihi(date);
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true
                      }
                    }}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    sm: 4,
                    lg: 2
                  }}>
                  <DatePicker
                    label="Bitiş Tarihi"
                    format="dd.MM.yyyy"
                    value={talepEdilmeBitisTarihi}
                    onChange={date => {
                      setTalepEdilmeBitisTarihi(date);
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true
                      }
                    }}
                  />
                </Grid>
              </LocalizationProvider>
              <Grid
                size={{
                  xs: 12,
                  sm: 4,
                  lg: 4
                }}>
                <Autocomplete
                  multiple
                  size="small"
                  id="multiple-limit-tags"
                  fullWidth
                  limitTags={1}
                  disableCloseOnSelect
                  value={selectedSmsSablonBasliklar}
                  options={smsSablonBasliklar}
                  getOptionLabel={option => (option.SABLON ? option.SABLON : '')}
                  onChange={(event, newValue) => {
                    setSelectedSmsSablonBasliklar(newValue);
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.SABLON}
                    </li>
                  )}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label="Şablon Başlıkları"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              {/* Markalar / Kullanıcılar / Sms Gönderim Durumları filters removed per request —
                  only Şablon Başlıkları remains as an active filter. Commented out, not deleted,
                  so it can be restored later if needed.
              <Grid item xs={12} sm={6} lg={4}>
                <Autocomplete
                  multiple
                  size="small"
                  id="multiple-limit-tags"
                  fullWidth
                  limitTags={1}
                  disableCloseOnSelect
                  value={selectedMarkalar}
                  options={smsMarkalar}
                  getOptionLabel={option => (option.MARKA_ADI ? option.MARKA_ADI : '')}
                  onChange={(event, newValue) => {
                    setSelectedMarkalar(newValue);
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.MARKA_ADI}
                    </li>
                  )}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label="Markalar"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={4}>
                <Autocomplete
                  multiple
                  size="small"
                  id="multiple-limit-tags"
                  fullWidth
                  limitTags={1}
                  disableCloseOnSelect
                  value={selectedSmsKullanicilar}
                  options={smsKullanicilar}
                  getOptionLabel={option => (option.KULLANICI_ADI ? option.KULLANICI_ADI : '')}
                  onChange={(event, newValue) => {
                    setSelectedSmsKullanicilar(newValue);
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.KULLANICI_ADI}
                    </li>
                  )}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label="Kullanıcılar"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6} lg={4}>
                <Autocomplete
                  size="small"
                  id="multiple-limit-tags"
                  fullWidth
                  value={selectedSmsGonderimDurumlar}
                  options={smsStatusOptions}
                  getOptionLabel={option => (option.label ? option.label : '')}
                  onChange={(event, newValue) => {
                    setSelectedSmsGonderimDurumlar(newValue);
                  }}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label="Sms Gönderim Durumları"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              */}
              <Grid
                size={{
                  xs: 12,
                  sm: 6,
                  lg: 2
                }}>
                <Button
                  className={styles.action}
                  variant="contained"
                  fullWidth
                  size='medium'
                  onClick={() => { SmsSonuclariniFiltreliAra(); }}
                  style={{ backgroundColor: '#FF9800', color: '#FFFFFF' }}
                  sx={{
                    backgroundColor: '#FF9800',
                    color: '#FFFFFF',
                    '&:hover': { backgroundColor: '#e68900' }
                  }}
                >
                  <span style={{ color: '#FFFFFF' }}>ARA</span>
                  <SearchIcon style={{ marginLeft: '5px', color: '#FFFFFF' }} />
                </Button>
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  sm: 6,
                  lg: 2
                }}>
                <Button
                  className={styles.action}
                  variant="contained"
                  fullWidth
                  size='medium'
                  onClick={() => {
                    handleExportClick(1);
                  }}
                  style={{ backgroundColor: '#FF9800', color: '#FFFFFF' }}
                  sx={{
                    backgroundColor: '#FF9800',
                    color: '#FFFFFF',
                    '&:hover': { backgroundColor: '#e68900' }
                  }}
                >
                  <span style={{ color: '#FFFFFF' }}>YAZDIR</span>
                  <PrintIcon style={{ marginLeft: '5px', color: '#FFFFFF' }} />
                </Button>
              </Grid>
              <Divider />
              <Box sx={{ height: 600, width: '100%', marginTop: 1 }}>
                <DataGrid
                  rows={smsGeneralData}
                  columns={columns}
                  getRowId={(row) =>
                    row.ID
                  }
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 100,
                      },
                    },
                  }}
                  slots={{ toolbar: QuickSearchToolbar }}
                  localeText={trTR.components.MuiDataGrid.defaultProps.localeText}
                  pageSizeOptions={[100]}
                />
              </Box>
            </Grid>
          </CardContent>
        </Container>
      </Card>
    </Page >
  );
}

export default SmsTrackingReport;